import axios from "@/utils/axiosHelper";

// 初始化数据(含授权)
export const onGetInitDataAPI = params => {
  return axios({ url: "/sword/new/book/init", method: "GET", params }, { interceptResultCode: false });
};

// 查询新服角色
export const onGetRolesAPI = data => {
  return axios({ url: "/sword/new/book/show", method: "get", data });
};

// 领取奖励
export const onExchangeProductAPI = data => {
  return axios({ url: "/sword/new/book/reward", method: "POST", data });
};

// 加入队伍
export const onEnterTeamAPI = data => {
  return axios({ url: "/sword/new/book/help", method: "POST", data }, { interceptResultCode: false });
};

// 预约人数
export const onGetNumberAPI = params => {
  return axios({ url: "/sword/new/book/number", method: "GET", params }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/hjwq/newArea-appoint/api.js